import { API_ROUTES } from '@memorai/routes';
import type { UpdateUserPreferencesInput, UserPreferences } from '@memorai/types';
import { apiFetch } from './client.js';

export async function fetchPreferences(): Promise<UserPreferences> {
    return apiFetch<UserPreferences>(API_ROUTES.PREFERENCES);
}

export async function updatePreferences(updates: UpdateUserPreferencesInput): Promise<UserPreferences> {
    return apiFetch<UserPreferences>(API_ROUTES.PREFERENCES, {
        method: 'PATCH',
        body: JSON.stringify(updates),
    });
}
